/**
 * Values for the `data-bv-show` prop
 * @see https://knowledge.bazaarvoice.com/wp-content/conversations/en_US/Display/display_integration.html#step-2-add-display-pages-for-the-ugc-features
 */
const BV_SHOW_OPTIONS = [
  'rating_summary',
  'reviews',
  'questions',
  'review_highlights',
  'inline_rating',
  'seller_ratings'
];

/**
 * Bazaar Voice Ratings: Base Component
 * @param {string} props - The accepted props: `className`, `productId`, and `show`
 * @param {string} props.className - The className passed from @emotion/styled
 * @param {string} props.productId - The `data-bv-product-id`, EXPECTED: product `slug` from Algolia
 * @param {string} props.show - The `data-bv-show`, EXPECTED: one of the BV_SHOW_OPTIONS
 * @returns {JSX.Element} - The Bazaar Voice Ratings component, ready for a style-wrapper component
 */
const BazaarVoiceRatings = ({ className, productId = 'product1', show = 'seller_ratings' }) => {
  // TODO: Validate the `show` prop
  return <div className={className} data-bv-show={show} data-bv-product-id={productId} />;
};

export default BazaarVoiceRatings;
